var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.95 18C14.8667 18 12.8043 17.55 10.763 16.65C8.72167 15.75 6.86733 14.4667 5.2 12.8C3.53267 11.1333 2.24933 9.28333 1.35 7.25C0.450667 5.21667 0.000666667 3.15 0 1.05V0H5.9L6.825 5.025L3.975 7.9C4.34167 8.55 4.75 9.16667 5.2 9.75C5.65 10.3333 6.13333 10.875 6.65 11.375C7.13333 11.8583 7.66267 12.321 8.238 12.763C8.81333 13.205 9.434 13.6173 10.1 14L13 11.1L18 12.125V18H16.95Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephone_icon.d79a086119144caa1ac32d4ef203ecc1.svg";
export { ForwardRef as ReactComponent };